export default __webpack_public_path__ + "static/media/Aegrus Mal.00511614.jpg";